import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=60fa816c&"
import script from "./Tutorial.vue?vue&type=script&lang=js&"
export * from "./Tutorial.vue?vue&type=script&lang=js&"
import style0 from "./Tutorial.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tutorial.vue"
export default component.exports